'use client';
import { Field } from './field.js';
import { FieldAffix, FieldAffixes } from './field-affix.js';
import { FieldCounter } from './field-counter.js';
import { FieldDescription } from './field-description.js';

/**
 * Field component, used to wrap a form field.
 *
 * @example
 * <Field>
 *   <Label>Kort beskrivelse</Label>
 *   <Field.Description>Beskrivelse</Field.Description>
 *   <Input />
 *   <ValidationMessage>Feilmelding</ValidationMessage>
 * </Field>
 */
const FieldComponent = Object.assign(Field, {
    Description: FieldDescription,
    Affixes: FieldAffixes,
    Affix: FieldAffix,
    Counter: FieldCounter,
});
FieldComponent.Description.displayName = 'Field.Description';
FieldComponent.Affixes.displayName = 'Field.Affixes';
FieldComponent.Affix.displayName = 'Field.Affix';
FieldComponent.Counter.displayName = 'Field.Counter';

export { FieldComponent as Field, FieldAffix, FieldAffixes, FieldCounter, FieldDescription };
